






















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestPaper from "@/store/entities/testPaper";
import url from "@/lib/url";

@Component({})
export default class PreviewTestPaper extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  testPaper: TestPaper = new TestPaper();
  correctAnswers: any = [];
  previewTestQuestions: any = [];
  paperName: string = "";
  screenWidth: number = document.body.clientWidth - 200;

  questionkey: any = [
    {
      key: "323",
    },
    {
      key: "323",
    },
    {
      key: "323",
    },
    {
      key: "323",
    },
    {
      key: "323",
    },
    {
      key: "323",
    },
  ];
  formTitle: string = "试卷预览";
  indexnum: number = 0;
  loadings: boolean = false;
  cancel() {
    this.visibleChange(false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.testPaper = Util.extend(
        true,
        {},
        this.$store.state.testPaper.editTestPaper
      );
      this.$store.state.testPaper.loadings = true;
      this.getpage();
      // this.$Message.loading({
      //   content: this.L('数据加载中，请等待'),
      //   duration: 5,
      // })
    }
  }

  usetotal(value) {
    if (value.length) {

      return value.map(Number).reduce((sum, current) => sum + current, 0);

    } else {
      return 0;
    }

  }
  UsdegreeDifficulty(value) {
    if (value === 1) {
      return "(A层次)";
    } else if (value === 2) {
      return "(B层次)";
    } else {
      return "(C层次)";
    }
  }
  async getpage() {
    // this.$Loading.start();
    await this.$store
      .dispatch({
        type: "testQuestion/previewTestPaper",
        data: this.testPaper,
      })
      .then((result) => {
        this.correctAnswers = result.correctAnswers;
        this.previewTestQuestions = result.previewTestQuestions;

        this.previewTestQuestions.forEach(item => {
          item.testQuestions.forEach(items => {
            if (!items.childFractions.length) {
              for (let index = 0; index < items.questionCount; index++) {
                items.childFractions.push('');
              }
            }
          });
        });
        this.paperName = result.name;
        this.loadings = true;
      });
    // this.$Loading.finish()
  }


  savechildfen() {
    let hasError = false; // 初始化标志变量  
    this.previewTestQuestions.forEach(item => {
      if (
        [3, 4, 5, 6, 7, 8, 9, 12].includes(item.questionType)
      ) {
        item.testQuestions.forEach(items => {
          let totalfen = 0;
          items.childFractions.forEach(el => {
            totalfen += el ? parseFloat(el) : 0;
          });
          if (totalfen !== items.score) {
            this.$Message.error({
              content: `${item.questionTypeName}:题号${items.sortNo}试题分数设置错误`,
              duration: 5,
            });
            hasError = true; // 标记发生了错误  
          }
        });
      }
    });
    // if (hasNoPrice) {
    //   // 这里可以添加额外的处理逻辑，比如阻止表单提交等  
    //   this.msg('存在未设置的价格');
    //   // 注意：some() 方法会在找到第一个未设置价格的元素时返回 true，  
    //   // 但循环仍然会停止，因为我们已经找到了需要处理的情况。  
    //   return true; // 返回 true 告诉 some() 我们已经找到了需要处理的元素  
    // }

    if (!hasError) {
      this.$store
        .dispatch({
          type: "testQuestion/ChangeTestPaperOfQuestion",
          data: { previewTestQuestions: this.previewTestQuestions },
        })
        .then((result) => {
          this.visibleChange(false);
        });
    }
  }


  //导出试卷
  exportTestPaper(isAnswer) {
    this.$store
      .dispatch({
        type: "testQuestion/exportTestPaper",
        data: { id: this.testPaper.id, questionOrAnswer: isAnswer },
      })
      .then((result) => {
        var ishttps = 'https:' == document.location.protocol ? true : false;
        if (ishttps) {
          let newurl = result.replace('http://', 'https://');
          window.location.href = newurl;
        } else {
          window.location.href = result;
        }



      });
  }
}
